import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";
import MatrixInput from "../testing/MatrixInput";
import TechniqueInput from "../testing/TechniqueInput";
import TestnameInput from "../testing/TestnameInput";
import AccreditationInput from "../testing/AccreditationInput";
import { fetchJson } from "../../lib/Fetching";

export default class TestFinder extends React.Component {
  state = {
    loadedTests: false,
    tests: [],
    selectedTests: [],
    filter: {
      testname_ids: [],
      technique_ids: [],
      accreditation_ids: [],
    },
  };

  isFormValid = () =>
    this.state.filter.testname_ids.length > 0 || this.state.filter.technique_ids.length > 0;

  fetchTests = (input) => {
    const { matrix_id } = this.props;
    const { filter } = this.state;
    fetchJson("/tests.json", { ...filter, matrix_id }).then((tests) =>
      this.setState({ tests, loadedTests: true, selectedTests: [] })
    );
  };

  handleSubmit = () => {
    const { selectedTests } = this.state;
    const { onSubmit } = this.props;
    if (selectedTests.length == 0) return;
    onSubmit(selectedTests.map((t) => t.id));
  };

  setFilter = (field, options) => {
    const { filter } = this.state;
    this.setState({
      loadedTests: false,
      tests: [],
      filter: {
        ...filter,
        [field]: options.map((o) => o.value),
      },
    });
  };

  visibleTests = () => {
    const { excludeTestIds } = this.props;
    const { tests } = this.state;
    return excludeTestIds ? tests.filter((t) => !excludeTestIds.includes(t.id)) : tests;
  };

  selectAllTests = () => {
    this.setState({ selectedTests: this.state.tests });
  };

  selectTest = (test, event) => {
    this.setState({
      selectedTests: event.target.checked
        ? this.state.selectedTests.concat(test)
        : this.state.selectedTests.filter((t) => t !== test),
    });
  };

  renderTests() {
    const { selectedTests, loadedTests } = this.state;
    const tests = this.visibleTests();
    if (tests.length == 0) {
      return loadedTests ? (
        <div style={{ padding: 10, border: "1px solid #DDD", marginTop: 20 }}>
          {I18n.t("No tests were found matching your criteria")}
        </div>
      ) : null;
    }
    return (
      <div>
        <hr />
        <Button
          disabled={selectedTests.length == 0}
          title={I18n.t("add_tests")}
          onClick={this.handleSubmit}
          primary
        />
        <table className="table table-condensed">
          <thead>
            <tr>
              <th style={{ width: 30 }}>
                <input type="checkbox" onChange={this.selectAllTests} />
              </th>
              <th>{I18n.t("test_name")}</th>
              <th>{I18n.t("matrix")}</th>
              <th>{I18n.t("technique")}</th>
              <th>{I18n.t("accreditation")}</th>
            </tr>
          </thead>
          <tbody>
            {tests.map((test) => (
              <tr key={test.id}>
                <td>
                  <input
                    onChange={this.selectTest.bind(this, test)}
                    type="checkbox"
                    checked={selectedTests.includes(test)}
                  />
                </td>
                <td>{test.test_name}</td>
                <td>{test.matrix_name}</td>
                <td>{test.technique_name}</td>
                <td>{test.accreditation_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { onCancel } = this.props;
    return (
      <div style={{ padding: 20 }}>
        <div className="row" style={{ marginBottom: 20 }}>
          <div className="col-md-5">
            <TechniqueInput
              width="100%"
              multiple
              onChange={(options) => this.setFilter("technique_ids", options)}
            />
          </div>
          <div className="col-md-4">
            <TestnameInput
              width="100%"
              multiple
              onChange={(options) => this.setFilter("testname_ids", options)}
              hideInternal
            />
          </div>
          <div className="col-md-3">
            <AccreditationInput
              width="100%"
              multiple
              onChange={(options) => this.setFilter("accreditation_ids", options)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Button
              disabled={!this.isFormValid()}
              title={I18n.t("find_tests")}
              onClick={this.fetchTests}
              icon="fa-search"
            />
            <Button title="Cancel" onClick={onCancel} style={{ marginLeft: 20 }} />
          </div>
        </div>
        {this.renderTests()}
      </div>
    );
  }
}
